import styled from 'styled-components';

import { Text } from '../../components';

export const Container = styled.div<{ $isUnAuthenticated?: boolean }>`
  display: flex;
  align-items: center;
  gap: 3rem;
  ${(props) => props.$isUnAuthenticated && 'margin-top: 3rem;'}
  padding: 5.75rem 9.69rem;
  max-width: 64rem;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    padding: 7.5rem 1.5rem;
    text-align: center;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 24rem;
`;

export const TextTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const TextTitleSmall = styled(Text)`
  font-size: ${({ theme }) => theme.fontVariants.desktop.caption.mdCaps.fontSize};
  line-height: ${({ theme }) => theme.fontVariants.desktop.caption.mdCaps.lineHeight};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  color: ${({ theme }) => theme.colors.neutrals.white};
  text-transform: uppercase;
`;

export const TextTitleLarge = styled(Text)`
  font-size: ${({ theme }) => theme.fontVariants.desktop.headline.h2.fontSize};
  line-height: ${({ theme }) => theme.fontVariants.desktop.headline.h2.lineHeight};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.colors.neutrals.white};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${({ theme }) => theme.fontVariants.mobile.headline.h2.fontSize};
    line-height: ${({ theme }) => theme.fontVariants.mobile.headline.h2.lineHeight};
  }
`;

export const TextBody = styled(Text)`
  font-size: ${({ theme }) => theme.fontVariants.desktop.buttons.sm.fontSize};
  line-height: ${({ theme }) => theme.fontVariants.desktop.buttons.sm.lineHeight};
  color: ${({ theme }) => theme.colors.neutrals.c300};
`;

export const TextBodyButton = styled.span`
  font-size: ${({ theme }) => theme.fontVariants.desktop.buttons.sm.fontSize};
  line-height: ${({ theme }) => theme.fontVariants.desktop.buttons.sm.lineHeight};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.colors.primary.c500};

  margin-left: 0.25rem;
  cursor: pointer;
`;
